<template>

<div :class="['list-view', list.length == 0 ? 'no-sub-header' : '']">

	<div v-if="list.length > 0" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<label>Receive Date</label>
		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList(1)">Filter Dates</div>
		</div>

		<div class="divider"></div>

		<label v-if="supplierFilterList.length > 0">Supplier</label>
		<select v-if="supplierFilterList.length > 0" v-model="filters.supplier_id" @change="getList(1)">
			<option value="">Select...</option>
			<option v-for="(supplier, index) in supplierFilterList" :value="supplier.supplier_id">{{ supplier.supplier_name }}</option>
		</select>

		<div class="divider"></div>

		<div class="button neutral" @click="clearFilters()">Clear Filters</div>
		<div v-if="enableExport" :class="['button', gettingExport ? 'disabled' : 'neutral']" @click="doExport()">Export CSV</div>

		<div class="divider"></div>

		<div class="button action" @click="addItem()">Start New Receipt</div>

		<div class="message">{{ exportMessage }}</div>

	</div>

	<div class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Date</th>
					<th class="list left">Supplier</th>
					<th class="list left">Invoice</th>
					<th class="list left">PO / Order</th>
					<th class="lis right">Freight</th>
					<th class="list right">Received</th>
					<th class="list right">Total Cost</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list left">{{ $moment(item.receipt_date).format('MM/DD/YYYY') }}</td>
				<td class="list left">{{ item.supplier_name }}</td>
				<td class="list left">{{ item.supplier_invoice }}</td>
				<td class="list left">{{ item.purchase_order_number || item.order_number }}</td>
				<td class="list right">{{ item.freight }}</td>
				<td class="list right">{{ item.received }}</td>
				<td class="list right">{{ item.received_cost }}</td>
			</tr>
		</table>

	</div>

	<div v-if="showSetSupplier" class="modal large-modal">
		<div class="inner">
			<h2 v-if="changeSupplierForReceiptId">Change Receipt Supplier</h2>
			<h2 v-else>Start New Receipt{{ this.$route.query.upc ? ' for UPC ' + this.$route.query.upc : '' }}</h2>
			<div class="content">
				<h3 style="text-align: center; margin: 1em 0;">Choose an option to start receiving</h3>
				<div class="receive-options">
					<div>
						<h2 class="small">Search for a supplier by name</h2>
						<div class="input-with-control" style="margin: 1em 0;">
							<input type="search" v-model="newSupplier.search_term" placeholder="Search..." @search="getListSuppliers()" ref="supplier_search_term">
							<div :class="['button', newSupplier.search_term ? 'action' : 'disabled', 'input-go']" @click="getListSuppliers()"><i class="fas fa-search"></i></div>
							<div :class="['search-message-under', { show: searchMessage }]">{{ searchMessage }}</div>
						</div>
						<label>Search for a supplier already in the system or one you've received from before.</label>
					</div>
					<div class="divider"><span class="divider-label"><i>OR</i></span></div>
					<div>
						<h2 class="small">Search for a supplier by FFL Number</h2>
						<div style="margin: 1em 0;">
							<ffl-number-search @searchResult="setList" />
						</div>
						<label>Enter an FFL Number to search the complete national database of over 80,000 FFLs.</label>
					</div>
					<div class="divider"><span class="divider-label"><i>OR</i></span></div>
					<div>
						<h2 class="small">Enter your PO or Distributor Order Number</h2>
						<div class="input-with-control" style="margin: 1em 0;">
							<input type="search" v-model="newSupplier.order_number" placeholder="Search..." @search="searchOrders()" ref="order_search_term">
							<div :class="['button', newSupplier.order_number ? 'action' : 'disabled', 'input-go']" @click="searchOrders()"><i class="fas fa-search"></i></div>
							<div :class="['search-message-under', { show: orderSearchMessage }]">{{ orderSearchMessage }}</div>
						</div>
						<label>If you created a Purchase Order or Distributor Order, you can enter the number to get the details.</label>
					</div>
				</div>

				<div v-if="supplierSearchList.length > 0" class="message-overlay">
					<label v-if="supplierSearchContext == 'customer'">No suppliers found, but </label>
					<label v-if="supplierSearchList.length > 1">{{ supplierSearchContext == 'customer' ? 'multiple customers' : 'Multiple suppliers' }} found...</label>
					<label v-else>{{ supplierSearchContext == 'customer' ? 'one customer' : 'One supplier' }} found...</label>
					<ul class="search-list" style="font-size: 0.9em; margin: 1em 0 0 0;">
						<li class="clickable-list-item" v-for="(supplier, index) in supplierSearchList" @click="assignSupplier(supplier)">
							<div class="two-columns left">
								<div>
									{{ supplier.full_name }}<br>
									<label v-if="supplier.ffl_number">FFL</label> {{ supplier.ffl_number }}
									<label v-if="supplier.drivers_license_number">DL</label> {{ supplier.drivers_license_number }}
								</div>
								<div>
									{{ supplier.address_1 }}<br>{{ supplier.city }} {{ supplier.state }} {{ supplier.zip_code }}<br>
								</div>
							</div>
						</li>
					</ul>
				</div>

				<div v-if="!changeSupplierForReceiptId" class="divider" style="margin: 2em 4em;"><span class="divider-label"><i>OR</i></span></div>
				<div v-if="!changeSupplierForReceiptId" class="center">
					<label>Can't find your supplier?</label>
					<div class="button neutral small" style="margin: 0 0 0 1em;" @click="createSupplier()">Create a New Supplier</div>
				</div>

			</div>
			<div class="controls">
				<div v-if="supplierSearchList.length > 0" @click="supplierSearchList = []" class="button neutral spaced">Search Again</div>
				<div v-else class="button neutral spaced" @click="clearAddItem()">Cancel</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{343:'Receive Inventory', 344:'Cost Averaging', 345:'Receive Serialized Non-Firearms Products', 346:'Receive Firearms', 347:'Printing Shelf and Box Labels'}" :tours="false"></help-popup>

</div>

</template>

<script>
import FFLNumberSearch from "@/components/FFLNumberSearch.vue"
import { join } from "path"
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'receive-inventory-list',
    components: {
		'ffl-number-search': FFLNumberSearch,
		'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			searchTip: '',
			page: 1,
			showPagination: false,
			showFilters: true,
			supplierFilterList: [],
			supplierSearchContext: '',
			filters: {},
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			paging: {},
			enableExport: true,
			exportMessage: '',
			gettingExport: false,
			saveMessage: '',
			newSupplier: {},
			showSetSupplier: false,
			searching: false,
			supplierSearchList: [],
			searchMessage: '',
			orderSearchMessage: '',
			changeSupplierForReceiptId: false
		}
	},
	created() {
		sessionStorage.removeItem('supplier_detail')
		if (sessionStorage.getItem('filtersInevntoryReceipts')) {
			this.filters = JSON.parse(sessionStorage.getItem('filtersInevntoryReceipts'))
			this.getList()
		} else {
			this.clearFilters()
		}
		if (sessionStorage.getItem('change_supplier')) {
			this.changeSupplierForReceiptId = sessionStorage.getItem('change_supplier')
			sessionStorage.removeItem('change_supplier')
			this.addItem()
		}
		if (this.$route.query.upc) {
			this.addItem()
		}
		// coming from purchase orders program
		if (this.$route.query.purchase_order_number) {
			this.newSupplier.order_number = this.$route.query.purchase_order_number
			this.searchOrders()
		}
	},
	computed: {
		canSave() {
			return this.client_id == this.listDetail.client_id && this.listDetail.description
		}
	},
	methods: {
		receiveFromPurchaseOrder(purchaseOrderId) {
		},
		clearFilters() {
			sessionStorage.removeItem('filtersInevntoryReceipts')
			this.filters = {
				page: 1,
				search_term: '',
				supplier_id: '',
				start_date: '',
				end_date: '',
				do_export: 0
			}
			this.getList(1)
		},
		getList(page) {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading inventory receipts...'
			this.messageStatus = 'waiting'
			if (page) {
				this.filters.page = page
			}
			let postObject = this.filters
			postObject.get_filters = 0
			if (this.supplierFilterList.length == 0) {
				postObject.get_filters = 1
			}
			this.apiCall({ destination: 'get_list_inventory_receipts', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.messageStatus = obj.status
				sessionStorage.setItem('filtersInevntoryReceipts', JSON.stringify(this.filters))
				if (this.filters.do_export) {
					this.filters.do_export = 0
					sessionStorage.setItem('filtersInevntoryReceipts', JSON.stringify(this.filters))
					setTimeout(() => {
						document.getElementById("download").src = obj.download_url
						this.gettingExport = false
						this.message = ''
					}, 1000)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
					if (obj.suppliers) {
						this.supplierFilterList = obj.suppliers
					}
					this.message = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getItem(item) {
			this.$router.push('/inventory/receive-inventory/' + item.inventory_receipt_id)
		},
		addItem() {
			this.showSetSupplier = true
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		},
		getListSuppliers(context) {
			if (this.searching) { return }
			this.searchMessage = ''
			this.supplierSearchList = []
			this.supplierSearchContext = context
			let apiAction = ''
			let searchTerm = ''
			switch(context) {
				case 'customers':
					searchTerm = this.newSupplier.search_term
					apiAction = 'get_list_inventory_suppliers'
					break;
				default:
					searchTerm = this.newSupplier.search_term
					apiAction = 'get_list_inventory_suppliers'
					break;
			}
			if (!searchTerm || !apiAction) { return }
			this.searching = true
			this.apiCall({ destination: apiAction, data: { search_term: searchTerm, context: context } }).then(obj => {
				this.searching = false
				if (obj.suppliers.length > 0) {
					switch(context) {
						case 'customers':
							this.supplierSearchList = obj.suppliers
							break
						default:
							this.supplierSearchList = obj.suppliers
							break
					}
				} else {
					if (!context) {
						this.getListSuppliers('customer')
					} else {
						this.searchMessage = 'Supplier not found'
						setTimeout(() => { this.searchMessage = '' }, 2000)
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setList(list) {
			this.supplierSearchList = list
		},
		assignSupplier(supplier) {
			if (supplier.ffl_list_id) {
				this.apiCall({ destination: 'get_supplier_from_ffl_search', data: supplier }).then(obj => {
					if (obj.status == 'success') {
						// pass this supplier info to the detail route
						sessionStorage.setItem('supplier_detail', JSON.stringify(obj.supplier_detail))
						// are we changing supplier for an existing receipt?
						if (this.changeSupplierForReceiptId && this.changeSupplierForReceiptId != 'new') {
							this.updateReceiptSupplier(obj.supplier_detail.supplier_id)
						} else {
							this.$router.push('/inventory/receive-inventory/new' + (this.$route.query.upc ? '?upc=' + this.$route.query.upc : ''))
						}
					} else {
						this.message = obj.message
					}
				}).catch(err => {
					console.log(err)
				})
			} else {
				// pass this supplier info to the detail route
				sessionStorage.setItem('supplier_detail', JSON.stringify(supplier))
				// are we changing supplier for an existing receipt?
				if (this.changeSupplierForReceiptId && this.changeSupplierForReceiptId != 'new') {
					this.updateReceiptSupplier(supplier.supplier_id)
				} else {
					this.$router.push('/inventory/receive-inventory/new' + (this.$route.query.upc ? '?upc=' + this.$route.query.upc : ''))
				}
			}
		},
		searchOrders() {
			if (!this.newSupplier.order_number) { return }
			this.orderSearchMessage = ''
			this.searching = true
			this.apiCall({ destination: 'get_item_receive_order', data: { search_term: this.newSupplier.order_number } }).then(obj => {
				this.searching = false
				if (obj.status == 'success') {
					if (obj.inventory_receipt_id) {
						this.$router.push('/inventory/receive-inventory/' + obj.inventory_receipt_id)
					} else {
						let supplierDetail = obj.order_supplier
						supplierDetail.order_number = obj.order_detail.order_number || obj.order_detail.purchase_order_number
						// pass this supplier info to the detail route
						sessionStorage.setItem('supplier_detail', JSON.stringify(supplierDetail))
						// are we changing supplier for an existing receipt?
						if (this.changeSupplierForReceiptId && this.changeSupplierForReceiptId != 'new') {
							this.updateReceiptSupplier(supplierDetail.supplier_id)
						} else {
							this.$router.push('/inventory/receive-inventory/new' + (this.$route.query.upc ? '?upc=' + this.$route.query.upc : ''))
						}
					}
				} else {
					this.orderSearchMessage = obj.message
                    setTimeout(() => { this.orderSearchMessage = '' }, 2000)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		createSupplier() {
			sessionStorage.removeItem('supplier_detail')
			let supplierDetail = { 
				client_id: this.client_id, 
				supplier_id: 'new', 
				supplier_type_id: '',
				last_name: '',
				company_name: '',
				address_1: '',
				city: '',
				state: '',
				zip_code: '',
				country_code: '',
				notes: [{ note: '', priority: '' }]
			}
			sessionStorage.setItem('supplier_detail', JSON.stringify(supplierDetail))
			this.$router.push('/inventory/receive-inventory/new' + (this.$route.query.upc ? '?upc=' + this.$route.query.upc : ''))
		},
		clearAddItem() {
			this.showSetSupplier = false
			this.newSupplier = {}
			this.supplierSearchList = []
			this.changeSupplierForReceiptId = ''
		},
		updateReceiptSupplier(supplierId) {
			this.apiCall({ destination: 'save_item_inventory_receipt_supplier', data: { inventory_receipt_id: this.changeSupplierForReceiptId, supplier_id: supplierId } }).then(obj => {
				if (obj.status == 'success') {
					this.$router.push('/inventory/receive-inventory/' + this.changeSupplierForReceiptId)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.receive-options {
	display: grid;
	grid-template-columns: 1fr;
	grid-column-gap: 0.5em;
	@media all and (min-width: 1400px) {
		grid-template-columns: 1fr 3em 1.33fr 3em 1fr;
	}
}
</style>
